// src/routes/PublicRoutes.jsx
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import * as P from "./LazyPublicPages";

const Loader = () => (
  <div className="page-loader">Loading...</div>
);

const PublicRoutes = ({ isMobile, showAlert }) => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>

        {/* LOGIN */}
        <Route
          path="/dashboard"
          element={
            isMobile
              ? <P.LoginUIMobile showAlert={showAlert} />
              : <P.LoginUI showAlert={showAlert} />
          }
        />

        {/* PASSWORD */}
        <Route
          path="/forgotpassword"
          element={<P.EmailSendUI showAlert={showAlert} />}
        />

        <Route
          path="/setpassword"
          element={<P.UserPasswordResetUI showAlert={showAlert} />}
        />

        {/* APPLY (PUBLIC PROFILE VIEW) */}
        <Route
          path="/apply"
          element={<P.MyProfile showAlert={showAlert} />}
        />

        {/* VACANCIES */}
        <Route
          path="/vacancies"
          element={
            isMobile
              ? <P.VacanciesMobUI showAlert={showAlert} />
              : <P.VacanciesUI showAlert={showAlert} />
          }
        />

        <Route
          path="/recruitervacancies"
          element={
            isMobile
              ? <P.RecruitmentVacancyPageMobUI showAlert={showAlert} />
              : <P.RecruitmentVacancyPageUI showAlert={showAlert} />
          }
        />

        {/* RECRUITER REGISTRATION */}
        <Route
          path="/recruiterRegistration"
          element={
            isMobile
              ? <P.RecruiterRegistrationPageMobUI />
              : <P.RecruiterRegistrationPageUI showAlert={showAlert} />
          }
        />

        {/* LEGAL */}
        <Route
          path="/termsandcondition"
          element={<P.TermsandConditions showAlert={showAlert} />}
        />

        <Route
          path="/privacypolicy"
          element={<P.PrivacyPolicy showAlert={showAlert} />}
        />

        {/* FALLBACK */}
        <Route
          path="*"
          element={
            isMobile
              ? <P.LoginUIMobile showAlert={showAlert} />
              : <P.LoginUI showAlert={showAlert} />
          }
        />

      </Routes>
    </Suspense>
  );
};

export default PublicRoutes;
